import axios from "axios";

const TOKEN_KEY = "dsx_admin_token";

export const getToken = () => sessionStorage.getItem(TOKEN_KEY);
export const setToken = (t) => (t ? sessionStorage.setItem(TOKEN_KEY, t) : sessionStorage.removeItem(TOKEN_KEY));

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/admin` });

api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t && !cfg.headers.Authorization) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && getToken() && !err.config?.url?.includes("/auth/")) {
      setToken(null);
      window.dispatchEvent(new Event("dsx-admin-logout"));
    }
    return Promise.reject(err);
  },
);

export const errorText = (err) => {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return d?.msg || String(d);
};

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" }) : "—");
